var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSlackIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "7 3 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Slack",
    filter: "url(#filter0_dd_2704_49765)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 42",
    x: 8,
    y: 4,
    width: 62,
    height: 62,
    rx: 32,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M30.7233 40.2209C30.7233 42.0711 29.2119 43.5825 27.3617 43.5825C25.5116 43.5825 24.0002 42.0711 24.0002 40.2209C24.0002 38.3708 25.5116 36.8594 27.3617 36.8594H30.7233V40.2209Z",
    fill: "#E01E5A"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M32.4163 40.2209C32.4163 38.3708 33.9277 36.8594 35.7778 36.8594C37.628 36.8594 39.1394 38.3708 39.1394 40.2209V48.6379C39.1394 50.488 37.628 51.9994 35.7778 51.9994C33.9277 51.9994 32.4163 50.488 32.4163 48.6379V40.2209Z",
    fill: "#E01E5A"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M35.7778 26.7231C33.9277 26.7231 32.4163 25.2117 32.4163 23.3616C32.4163 21.5114 33.9277 20 35.7778 20C37.628 20 39.1394 21.5114 39.1394 23.3616V26.7231H35.7778Z",
    fill: "#36C5F0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M35.7787 28.418C37.6288 28.418 39.1402 29.9294 39.1402 31.7795C39.1402 33.6297 37.6288 35.1411 35.7787 35.1411H27.3617C25.5116 35.1411 24.0002 33.6297 24.0002 31.7795C24.0002 29.9294 25.5116 28.418 27.3617 28.418H35.7787Z",
    fill: "#36C5F0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M49.2755 31.7795C49.2755 29.9294 50.7869 28.418 52.637 28.418C54.4872 28.418 55.9986 29.9294 55.9986 31.7795C55.9986 33.6297 54.4872 35.1411 52.637 35.1411H49.2755V31.7795Z",
    fill: "#2EB67D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M47.5827 31.7785C47.5827 33.6287 46.0713 35.1401 44.2211 35.1401C42.371 35.1401 40.8596 33.6287 40.8596 31.7785V23.3616C40.8596 21.5114 42.371 20 44.2211 20C46.0713 20 47.5827 21.5114 47.5827 23.3616V31.7785Z",
    fill: "#2EB67D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M44.2209 45.2773C46.0711 45.2773 47.5825 46.7887 47.5825 48.6389C47.5825 50.4891 46.0711 52.0005 44.2209 52.0005C42.3708 52.0005 40.8594 50.4891 40.8594 48.6389V45.2773H44.2209Z",
    fill: "#ECB22E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M44.2211 43.5825C42.371 43.5825 40.8596 42.0711 40.8596 40.2209C40.8596 38.3708 42.371 36.8594 44.2211 36.8594H52.6381C54.4882 36.8594 55.9996 38.3708 55.9996 40.2209C55.9996 42.0711 54.4882 43.5825 52.6381 43.5825H44.2211Z",
    fill: "#ECB22E"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_2704_49765",
    x: 0,
    y: 0,
    width: 80,
    height: 80,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0823529 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2704_49765"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.082353 0 0 0 0 0.101961 0 0 0 0 0.156863 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2704_49765",
    result: "effect2_dropShadow_2704_49765"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_2704_49765",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlackIcon);
export default __webpack_public_path__ + "static/media/slack-icon.ccc8989c88bb7fa81b53d907727b1bb1.svg";
export { ForwardRef as ReactComponent };